<template>
    <div
        ref="el"
        class="join flex-nowrap flex justify-center w-full"
    >
        <button
            v-if="direction == 'prev'"
            class="join-item btn btn-sm h-12"
            @click="selectPage(page)"
        >
            {{ t('product.infiniteScroll.loadPrev') }}
            <div v-if="loading" class="loading loading-spinner" />
        </button>
        <div v-else class="join-item loading loading-spinner h-6 w-6 mb-6" />
    </div>
</template>

<script setup lang="ts">
import { computed , onUnmounted } from 'vue'
import { usePage, showError } from '#imports'
import type { HblProductListing, HblProductListingFilterCurrent } from '@/utils/types'
import { useI18n } from 'vue-i18n'

const {t} = useI18n()

interface ProductListingPaginationProps {
    page: number,
    limit: number,
    sorting: string,
    total: number,
    currentFilters: HblProductListingFilterCurrent,
    direction: string
}

const props = withDefaults(defineProps<ProductListingPaginationProps>(), {
})

const lastPage = computed(() => {
    return props.page > Math.ceil(props.total / props.limit)
})

const loading = ref(false)
const { getProductListing, updateUri } = usePage()
const emit = defineEmits<{(event: 'update:listing', data: HblProductListing): void}>()
async function selectPage (page: number): Promise<void> {
    try {
        loading.value = true
        const { productListing, params } = await getProductListing(props.currentFilters, props.limit, props.sorting, page)
        emit('update:listing', productListing)
        updateUri(params)
        loading.value = false
    } catch (e) {
        showError(e)
    }
}

const el = ref()
const observer = ref()
onMounted(() => {

    if(!lastPage.value && props.direction == 'next') {
        const options = {
            threshold: 0.5
        }
        observer.value = new IntersectionObserver(function(entries) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    selectPage(props.page)
                }
            })
        }, options)

        observer.value?.observe(el.value)
    }
})

onUnmounted(() => {
    if(observer.value != null){
        observer.value?.disconnect()
    }
})
</script>
